
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as passkeysoq6NtSKD_UXjUYdx1UG_UNkL9EL8E_ns4gzgpu2S2DsMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/modules/uk/runtime/pages/passkeys.vue?macro=true";
import { default as bingo_45lobbyZwckz9pADqmZkqi1JW7nBxGANHrsX5a8V2Dv45Lmh0AMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/modules/uk/runtime/pages/bingo-lobby.vue?macro=true";
import { default as redirect_45assistantxyjwIOmCe1fGCMDBmbjlWrIJ5zTQc4tBZ7czuqCiU2wMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/core/modules/payment/runtime/pages/redirect-assistant.vue?macro=true";
import { default as _91txId_93_AOjTJN_7CpQDW_Snm0dv5lBUZJsZnuRsoyLj9TlBDkMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/core/modules/payment/runtime/pages/pending/[txId].vue?macro=true";
import { default as modalo2bHPIMQix24ZHYDTSJbMgBBAg2LmyNDpi4TEPZMnfQMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/core/modules/promotion/runtime/pages/preview/modal.vue?macro=true";
import { default as _91slug_93n4vmqX39pQWUyDRCPCE0TnsaHNSjg6_9HvH78YGnuWkMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/games/entrance/[slug].vue?macro=true";
import { default as loginyBJU9oHiWvQViGggwcv5l3imm9ocJMK5LdPeE1NcnzEMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/playgame/login.vue?macro=true";
import { default as _91slug_93Bv4TqRJFLh_vx3txT4YvsfEXJ7BQr6aSfmVpj_uv894Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93jWIUsGWe9MvIGpffJuId1bcH5YH03gXUy7_l___45toMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/press/[slug].vue?macro=true";
import { default as _91token_93_2aGElytCG7ollfO3_VyJDkorI_Kw_PLvPS_45TKQXsMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/reset-password/[token].vue?macro=true";
import { default as about_45usrnBu4KOVeEZxHnl1rASdRCtoaQH_20PkPemMysVcA1kMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/about-us.vue?macro=true";
import { default as affiliatelrCXnbBrfye38xhZpttW1f3OzDOvxjQVXe0Eyb_T_lAMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/affiliate.vue?macro=true";
import { default as indexT1flD__wwFsbpLtenbvJIZWcH6u0YqW_8JCwY_AJuhAMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/allslots/index.vue?macro=true";
import { default as bingotuJCM8h1dN3_XoG97OkXPFN0_qpllZV3rYTmUKCgISUMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/bingo.vue?macro=true";
import { default as indexoJsjrja_1AHesjnnqfQ8ynp3wH9LGmCVg3m7gcI4dAAMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/blog/index.vue?macro=true";
import { default as bonus_45wheelXPGYLiUjN6w0lXKwyiTo5lUyoRkDFzH4HniBeQGCOZ4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/bonus-wheel.vue?macro=true";
import { default as cookiepolicyBoRRLXofCnA3aqdVhl3ZpJS8DuSnQFQOZK7zMqqa_9AMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/cookiepolicy.vue?macro=true";
import { default as customer_45supportT1PFIHn_p84KYf3z_M8uoblcYLdYHynrl_wxDldfDO0Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/customer-support.vue?macro=true";
import { default as faqk_TA_Mhv91ewTFdzftXZ5Yen4N8f5199JdZwxB5tPVwMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/faq.vue?macro=true";
import { default as lobby6vz7Enhn1D92g6m3plHbXnfCig4nRLlPk_fpfFJ2wPMMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/lobby.vue?macro=true";
import { default as indexrG_RU5CWqMIxnBXYkyfziYmlS3cua1ssFtlaPxOlya4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/playgame/index.vue?macro=true";
import { default as index8vNphjU6CB_b1RAX9qMXxd5NeGVJqtda9ZAzRxju1bIMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/press/index.vue?macro=true";
import { default as privacy_45policyOn92v26UZ0T3UPJWxmJvOaozpygmpJr8bbFhgkfXuPwMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/privacy-policy.vue?macro=true";
import { default as safer_45gamblingx3ITgvKUaUoeAKWyry2S_jmSPbzeUimxbgI6FZC5Zj4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/safer-gambling.vue?macro=true";
import { default as slots_45lobby_Utpl_ODp5B5CGA_CTC_JYjSMPzfvNuh7wEiDX_9B7cMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/slots-lobby.vue?macro=true";
import { default as termsRPcJ0HiiIszQt_gOSzbnrCkgwzaNo_jvhnvE7iipvAoMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/terms.vue?macro=true";
import { default as tvQvU0sX9JP8qB_EWiFMqW9HYFIubxQE8T8AGzPZf95ZwMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/tv.vue?macro=true";
import { default as _91reportId_93RTdBVHYx9_XUzkqQrgTrklMH1CZKEn118WTJGiJnuu4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/user-report/[reportId].vue?macro=true";
import { default as check_45informationC2d4pJctwwkhiszsK4VxVzkJL8TwFkhl_xsqye0sRWIMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/check-information.vue?macro=true";
import { default as deactivated_OEHlwNIg6BNWLM1bM_tcxyVFJtqZCIFd58GyITAXFEMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/deactivated.vue?macro=true";
import { default as delete_45account__g6Z4nZwzRu2rSXmFaDuZw8KKBM3CwI_s_JQNCqwLUMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/delete-account.vue?macro=true";
import { default as depositAO6MPLeq_XLNG2AKs1XCIs5DUylXLnewsAjPQtx5piQMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/deposit.vue?macro=true";
import { default as editBmhktvfUblI_wmTxulEVVNe6aUouow7qqBLamp1HVHkMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/edit.vue?macro=true";
import { default as homeT03dlidod78e_83ag0uNAQqfVntEYQuDHdpe0WHLly4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/home.vue?macro=true";
import { default as messagesntvPoC1hhNX76r7F2gWTmrH5_RcDmoBjMP891ObJ0lAMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/messages.vue?macro=true";
import { default as money_45limitsmEBSTT_Mo3ehNgXaclzMvlFF782kKPb_fojG1Eq1INYMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/money-limits.vue?macro=true";
import { default as my_45bonusesopxo_DdRNGLMJv6GBWo0kX7a1qHY9K2Bg1i1HUPDJyAMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/my-bonuses.vue?macro=true";
import { default as payment_45limit_45warningt1EIFKwWyHwmJlpC6Pi2aKs8ivCWftS6zsTzHHDJta4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/payment-limit-warning.vue?macro=true";
import { default as reached_45play_45limitsbq7pwwK_QxALIt5_lpnoUyRqIOK5Q28TjpCVTD9vJb8Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/reached-play-limits.vue?macro=true";
import { default as reality_45checkFxmsz8bDjmSJvmjYGRuqMlCt_xoEN9vttEKxskAIuuoMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/reality-check.vue?macro=true";
import { default as safer_45gamblingqkNaplaWIPUn6VidWL0jhMqz5Ap1_QRlfJOctGykMeAMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/safer-gambling.vue?macro=true";
import { default as saved_45gamesrjG8E11YUfEOH9m_djys5JrDrYkMJNpGbmlDqjlohysMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/saved-games.vue?macro=true";
import { default as self_45exclusionALz_W8aG3VuEeiiyh_e33gDUwa3eZlAw_N2FyS_q89UMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/self-exclusion.vue?macro=true";
import { default as sumsub_45verificationFqRlQzdfJFMRHwWj_VEyjvm0rUzBN_WauXcvpDkMIDMMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/sumsub-verification.vue?macro=true";
import { default as suspendedQVstCWUF6vHNr9u79Csk0Ke9p1krOBeo29_2FgpgyCAMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/suspended.vue?macro=true";
import { default as time_45outvo_VdtieSH16HIAVeYDDPpsUizJifn2Fk_4qqi_hNnsMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/time-out.vue?macro=true";
import { default as withdrawCY8i_06Z2YcGgzwSPmRsfg6SIrQfajTkUmY3YH8q_b4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/withdraw.vue?macro=true";
import { default as usersfXy561Cn0q8BPhSTHDFt3TP2lgPRDhH5qKcnJNdWmv8Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users.vue?macro=true";
import { default as winnersLZ8p917myL286Ux493bj2j5y0BUdf4_qN3J1moHuV0kMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/winners.vue?macro=true";
import { default as indextQyTyVmtNQziWjOKFhRKGleURatYk0s5_C28N1eaDFkMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/index.vue?macro=true";
import { default as component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8 } from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "users-passkeys",
    path: "/users/passkeys",
    meta: passkeysoq6NtSKD_UXjUYdx1UG_UNkL9EL8E_ns4gzgpu2S2DsMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/modules/uk/runtime/pages/passkeys.vue")
  },
  {
    name: "bingo-lobby",
    path: "/bingo-lobby",
    meta: bingo_45lobbyZwckz9pADqmZkqi1JW7nBxGANHrsX5a8V2Dv45Lmh0AMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/modules/uk/runtime/pages/bingo-lobby.vue")
  },
  {
    name: "redirect-assistant",
    path: "/payments/redirect-assistant",
    meta: redirect_45assistantxyjwIOmCe1fGCMDBmbjlWrIJ5zTQc4tBZ7czuqCiU2wMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/core/modules/payment/runtime/pages/redirect-assistant.vue")
  },
  {
    name: "payments-pending",
    path: "/payments/pending/:txId",
    meta: _91txId_93_AOjTJN_7CpQDW_Snm0dv5lBUZJsZnuRsoyLj9TlBDkMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/core/modules/payment/runtime/pages/pending/[txId].vue")
  },
  {
    name: "preview-promotions-modal",
    path: "/preview/promotions/modal",
    meta: modalo2bHPIMQix24ZHYDTSJbMgBBAg2LmyNDpi4TEPZMnfQMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/core/modules/promotion/runtime/pages/preview/modal.vue")
  },
  {
    name: "games-entrance-slug",
    path: "/games/entrance/:slug()",
    meta: { ...(_91slug_93n4vmqX39pQWUyDRCPCE0TnsaHNSjg6_9HvH78YGnuWkMeta || {}), ...{"middleware":["entrance"]} },
    alias: ["/game/:slug","/allslots/entrance/:slug"],
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/games/entrance/[slug].vue")
  },
  {
    name: "playgame-login",
    path: "/playgame/login",
    meta: { ...(loginyBJU9oHiWvQViGggwcv5l3imm9ocJMK5LdPeE1NcnzEMeta || {}), ...{"middleware":["playgame-login"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/playgame/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93Bv4TqRJFLh_vx3txT4YvsfEXJ7BQr6aSfmVpj_uv894Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/blog/[slug].vue")
  },
  {
    name: "press-slug",
    path: "/press/:slug()",
    meta: _91slug_93jWIUsGWe9MvIGpffJuId1bcH5YH03gXUy7_l___45toMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/press/[slug].vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    meta: { ...(_91token_93_2aGElytCG7ollfO3_VyJDkorI_Kw_PLvPS_45TKQXsMeta || {}), ...{"middleware":["guest-only"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/reset-password/[token].vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    meta: about_45usrnBu4KOVeEZxHnl1rASdRCtoaQH_20PkPemMysVcA1kMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/about-us.vue")
  },
  {
    name: "affiliate",
    path: "/affiliate",
    meta: affiliatelrCXnbBrfye38xhZpttW1f3OzDOvxjQVXe0Eyb_T_lAMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/affiliate.vue")
  },
  {
    name: "allslots",
    path: "/allslots",
    meta: { ...(indexT1flD__wwFsbpLtenbvJIZWcH6u0YqW_8JCwY_AJuhAMeta || {}), ...{"middleware":["landing-page","slots-landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/allslots/index.vue")
  },
  {
    name: "bingo",
    path: "/bingo",
    meta: { ...(bingotuJCM8h1dN3_XoG97OkXPFN0_qpllZV3rYTmUKCgISUMeta || {}), ...{"middleware":["landing-page","bingo-landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/bingo.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexoJsjrja_1AHesjnnqfQ8ynp3wH9LGmCVg3m7gcI4dAAMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/blog/index.vue")
  },
  {
    name: "bonus-wheel",
    path: "/bonus-wheel",
    meta: { ...(bonus_45wheelXPGYLiUjN6w0lXKwyiTo5lUyoRkDFzH4HniBeQGCOZ4Meta || {}), ...{"middleware":["landing-page"]} },
    alias: ["/promo-wheel","/ht-promo-wheel"],
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/bonus-wheel.vue")
  },
  {
    name: "cookiepolicy",
    path: "/cookiepolicy",
    meta: cookiepolicyBoRRLXofCnA3aqdVhl3ZpJS8DuSnQFQOZK7zMqqa_9AMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/cookiepolicy.vue")
  },
  {
    name: "customer-support",
    path: "/customer-support",
    meta: customer_45supportT1PFIHn_p84KYf3z_M8uoblcYLdYHynrl_wxDldfDO0Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/customer-support.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: faqk_TA_Mhv91ewTFdzftXZ5Yen4N8f5199JdZwxB5tPVwMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/faq.vue")
  },
  {
    name: "lobby",
    path: "/lobby",
    meta: { ...(lobby6vz7Enhn1D92g6m3plHbXnfCig4nRLlPk_fpfFJ2wPMMeta || {}), ...{"middleware":["recurring-consent"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/lobby.vue")
  },
  {
    name: "playgame",
    path: "/playgame",
    meta: { ...(indexrG_RU5CWqMIxnBXYkyfziYmlS3cua1ssFtlaPxOlya4Meta || {}), ...{"middleware":["playgame"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/playgame/index.vue")
  },
  {
    name: "press",
    path: "/press",
    meta: index8vNphjU6CB_b1RAX9qMXxd5NeGVJqtda9ZAzRxju1bIMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/press/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyOn92v26UZ0T3UPJWxmJvOaozpygmpJr8bbFhgkfXuPwMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/privacy-policy.vue")
  },
  {
    name: "safer-gambling",
    path: "/safer-gambling",
    meta: safer_45gamblingx3ITgvKUaUoeAKWyry2S_jmSPbzeUimxbgI6FZC5Zj4Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/safer-gambling.vue")
  },
  {
    name: "slots-lobby",
    path: "/slots-lobby",
    meta: slots_45lobby_Utpl_ODp5B5CGA_CTC_JYjSMPzfvNuh7wEiDX_9B7cMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/slots-lobby.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsRPcJ0HiiIszQt_gOSzbnrCkgwzaNo_jvhnvE7iipvAoMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/terms.vue")
  },
  {
    name: "tv",
    path: "/tv",
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/tv.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: { ...(usersfXy561Cn0q8BPhSTHDFt3TP2lgPRDhH5qKcnJNdWmv8Meta || {}), ...{"groups":["users"],"middleware":["require-auth"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users.vue"),
    children: [
  {
    name: "users-user-report-reportId",
    path: "user-report/:reportId()",
    meta: { ...(_91reportId_93RTdBVHYx9_XUzkqQrgTrklMH1CZKEn118WTJGiJnuu4Meta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/user-report/[reportId].vue")
  },
  {
    name: "users-check-information",
    path: "check-information",
    meta: { ...(check_45informationC2d4pJctwwkhiszsK4VxVzkJL8TwFkhl_xsqye0sRWIMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/check-information.vue")
  },
  {
    name: "users-deactivated",
    path: "deactivated",
    meta: { ...(deactivated_OEHlwNIg6BNWLM1bM_tcxyVFJtqZCIFd58GyITAXFEMeta || {}), ...{"groups":["users","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/deactivated.vue")
  },
  {
    name: "users-delete-account",
    path: "delete-account",
    meta: { ...(delete_45account__g6Z4nZwzRu2rSXmFaDuZw8KKBM3CwI_s_JQNCqwLUMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/delete-account.vue")
  },
  {
    name: "users-deposit",
    path: "deposit",
    meta: { ...(depositAO6MPLeq_XLNG2AKs1XCIs5DUylXLnewsAjPQtx5piQMeta || {}), ...{"groups":["users"],"middleware":["clean-view-param"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/deposit.vue")
  },
  {
    name: "users-edit",
    path: "edit",
    meta: { ...(editBmhktvfUblI_wmTxulEVVNe6aUouow7qqBLamp1HVHkMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/edit.vue")
  },
  {
    name: "users-home",
    path: "home",
    meta: { ...(homeT03dlidod78e_83ag0uNAQqfVntEYQuDHdpe0WHLly4Meta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/home.vue")
  },
  {
    name: "users-messages",
    path: "messages",
    meta: { ...(messagesntvPoC1hhNX76r7F2gWTmrH5_RcDmoBjMP891ObJ0lAMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/messages.vue")
  },
  {
    name: "users-money-limits",
    path: "money-limits",
    meta: { ...(money_45limitsmEBSTT_Mo3ehNgXaclzMvlFF782kKPb_fojG1Eq1INYMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/money-limits.vue")
  },
  {
    name: "users-my-bonuses",
    path: "my-bonuses",
    meta: { ...(my_45bonusesopxo_DdRNGLMJv6GBWo0kX7a1qHY9K2Bg1i1HUPDJyAMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/my-bonuses.vue")
  },
  {
    name: "users-payment-limit-warning",
    path: "payment-limit-warning",
    meta: { ...(payment_45limit_45warningt1EIFKwWyHwmJlpC6Pi2aKs8ivCWftS6zsTzHHDJta4Meta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/payment-limit-warning.vue")
  },
  {
    name: "users-reached-play-limits",
    path: "reached-play-limits",
    meta: { ...(reached_45play_45limitsbq7pwwK_QxALIt5_lpnoUyRqIOK5Q28TjpCVTD9vJb8Meta || {}), ...{"groups":["users","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/reached-play-limits.vue")
  },
  {
    name: "users-reality-check",
    path: "reality-check",
    meta: { ...(reality_45checkFxmsz8bDjmSJvmjYGRuqMlCt_xoEN9vttEKxskAIuuoMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/reality-check.vue")
  },
  {
    name: "users-safer-gambling",
    path: "safer-gambling",
    meta: { ...(safer_45gamblingqkNaplaWIPUn6VidWL0jhMqz5Ap1_QRlfJOctGykMeAMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/safer-gambling.vue")
  },
  {
    name: "users-saved-games",
    path: "saved-games",
    meta: { ...(saved_45gamesrjG8E11YUfEOH9m_djys5JrDrYkMJNpGbmlDqjlohysMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/saved-games.vue")
  },
  {
    name: "users-self-exclusion",
    path: "self-exclusion",
    meta: { ...(self_45exclusionALz_W8aG3VuEeiiyh_e33gDUwa3eZlAw_N2FyS_q89UMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/self-exclusion.vue")
  },
  {
    name: "users-sumsub-verification",
    path: "sumsub-verification",
    meta: { ...(sumsub_45verificationFqRlQzdfJFMRHwWj_VEyjvm0rUzBN_WauXcvpDkMIDMMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/sumsub-verification.vue")
  },
  {
    name: "users-suspended",
    path: "suspended",
    meta: { ...(suspendedQVstCWUF6vHNr9u79Csk0Ke9p1krOBeo29_2FgpgyCAMeta || {}), ...{"groups":["users","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/suspended.vue")
  },
  {
    name: "users-time-out",
    path: "time-out",
    meta: { ...(time_45outvo_VdtieSH16HIAVeYDDPpsUizJifn2Fk_4qqi_hNnsMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/time-out.vue")
  },
  {
    name: "users-withdraw",
    path: "withdraw",
    meta: { ...(withdrawCY8i_06Z2YcGgzwSPmRsfg6SIrQfajTkUmY3YH8q_b4Meta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/(users)/users/withdraw.vue")
  }
]
  },
  {
    name: "winners",
    path: "/winners",
    meta: winnersLZ8p917myL286Ux493bj2j5y0BUdf4_qN3J1moHuV0kMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@spilnu/uk/app/pages/winners.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indextQyTyVmtNQziWjOKFhRKGleURatYk0s5_C28N1eaDFkMeta || {}), ...{"middleware":["landing-page","home-landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/app/pages/index.vue")
  },
  {
    name: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8Meta?.name,
    path: "/responsible-gambling",
    component: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8
  },
  {
    name: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8Meta?.name,
    path: "/bingo-me",
    component: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8
  },
  {
    name: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8Meta?.name,
    path: "/promo-wheel",
    component: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8
  },
  {
    name: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8Meta?.name,
    path: "/ht-promo-wheel",
    component: component_45stubYqU5J1yC_8LFNCzIxmAc4yX7z5xZ4Q_XZWMzNeVi3L8
  }
]